import React from 'react';
import PortfolioItem from './PortfolioItem';

export default class Portfolio extends React.Component {


    constructor()
    {
        super();
        this.dados=[];

        this.state = {
    todos: [],
    currentPage: 1,
    todosPerPage: 8        
  };
  
  this.handleClick = this.handleClick.bind(this);

    }


    
    lapsList() {
        return this.state.todos.map((item,i) => <PortfolioItem key={i} image={item.urlp} alt={item.nome} title={item.nome} text={item.nome}/>);
    }


    componentDidMount() {
        let url = process.env.PUBLIC_URL + "/xml/portfolio.json";
        fetch(url)
            .then((response) => response.json()
                .then((data) => {
                    if(response.ok) {
                        this.setState({ todos: data })
						console.log ('deu certo');
						//document.querySelector(".carregando").style.display = "none";
                    }
                })
            ).catch(
            error => console.log(error)
            );
    	}

      handleClick(event) {
        this.setState({
          currentPage: Number(event.target.id)
        });
      }

    render(){

        const { todos, currentPage, todosPerPage } = this.state;

        // Logic for displaying todos
        const indexOfLastTodo = currentPage * todosPerPage;
        const indexOfFirstTodo = indexOfLastTodo - todosPerPage;
        const currentTodos = todos.slice(indexOfFirstTodo, indexOfLastTodo);
    
        const renderTodos = currentTodos.map((item, i) => {
          //return <li key={index}>{todo}</li>;
          return <PortfolioItem key={i} image={item.urlp} alt={item.nome} title={item.nome} text={item.nome}/>;
        });
    
        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(todos.length / todosPerPage); i++) {
          pageNumbers.push(i);
        }
    
        const renderPageNumbers = pageNumbers.map(number => {
          return (
            <li className="btn btn-outline-info btn-sm"
              key={number}
              id={number}
              onClick={this.handleClick}
            >
              {number}
            </li>
          );
        });
    
        return (
          <>


            <section className="page-section portfolio" id="portfolio">
                <div className="container">

                <h2 className="page-section-heading text-center text-uppercase text-secondary mb-0">Veja alguns de nossos clientes!</h2>

                <div className="divider-custom">
                    <div className="divider-custom-line"></div>
                    <div className="divider-custom-icon">
                    <i className="fa fa-star"></i>
                    </div>
                    <div className="divider-custom-line"></div>
                </div>

                <div className="row">
                {renderTodos}
                </div>
                <ul id="page-numbers">
                {renderPageNumbers}
                </ul>

                </div>
            </section>

          </>
        );
      }

}